/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ng2-translate/src/translate.pipe';
import * as import2 from 'ng2-translate/src/translate.service';
import * as import3 from '@angular/common';
import * as import4 from '../../buttons/link/link.component.ngfactory';
import * as import5 from '../../buttons/link/link.component';
import * as import6 from '../../buttons/button/button.component.ngfactory';
import * as import7 from '../../buttons/button/button.component';
import * as import8 from '../../orchestration/session.model';
import * as import9 from '../../orchestration/responsive.service';
import * as import10 from '../../notification/message/message.component.ngfactory';
import * as import11 from '../../notification/message/message.component';
import * as import12 from '../../notification/notification.service';
import * as import13 from '../../html-utils/html.pipe';
import * as import14 from '@angular/platform-browser';
import * as import15 from './ordering-context-panel.component';
import * as import16 from '../ordering-context.model';
import * as import17 from '../../order/order.model';
import * as import18 from '../../orchestration/navigation.service';
const styles_OrderingContextPanelComponent:any[] = ([] as any[]);
export const RenderType_OrderingContextPanelComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_OrderingContextPanelComponent,
  data: {}
}
);
function View_OrderingContextPanelComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'ordering-context-body-summary-primary-order-type'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform(co.summaryOrderType));
    ck(v,1,0,currVal_0);
  });
}
function View_OrderingContextPanelComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'ordering-context-body-summary-primary-asap-eta'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpod(['eta']),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,3).transform('woa.heading.ordering-context.eta',ck(v,2,0,co.orderModel.orderEta)));
    ck(v,1,0,currVal_0);
  });
}
function View_OrderingContextPanelComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'ordering-context-body-summary-primary-asap'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'ordering-context-body-summary-primary-asap-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_OrderingContextPanelComponent_4)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import3.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = ((co.orderingContextModel.canShowETA && !import0.ɵunv(v,7,0,import0.ɵnov(v,8).transform(co.OrderingContextEvents.evaluatingExpectedCompletionChange$))) && co.orderModel.orderEta);
    ck(v,7,0,currVal_1);
  },(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,3,0,import0.ɵnov(v,4).transform('woa.heading.ordering-context.asap'));
    ck(v,3,0,currVal_0);
  });
}
function View_OrderingContextPanelComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'ordering-context-body-summary-primary-time'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.summaryTime;
    ck(v,1,0,currVal_0);
  });
}
function View_OrderingContextPanelComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'ordering-context-body-summary-primary-table'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.summaryTable;
    ck(v,1,0,currVal_0);
  });
}
function View_OrderingContextPanelComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'ordering-context-body-summary-primary-from-store'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpod(['store']),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1)
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,0,0,ck(v,3,0,import0.ɵnov((<any>(<any>v.parent).parent),0),import0.ɵunv(v,0,0,import0.ɵnov(v,2).transform('woa.heading.ordering-context.fromStore',ck(v,1,0,co.primaryStore)))));
    ck(v,0,0,currVal_0);
  });
}
function View_OrderingContextPanelComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'ordering-context-body-summary-primary-to-address'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpod(['address']),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1)
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,0,0,ck(v,3,0,import0.ɵnov((<any>(<any>v.parent).parent),0),import0.ɵunv(v,0,0,import0.ɵnov(v,2).transform('woa.heading.ordering-context.toAddress',ck(v,1,0,co.primaryAddress)))));
    ck(v,0,0,currVal_0);
  });
}
function View_OrderingContextPanelComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),19,'div',[[
        'class',
        'ordering-context-body-summary-primary'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextPanelComponent_2)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextPanelComponent_3)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextPanelComponent_5)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextPanelComponent_6)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextPanelComponent_7)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextPanelComponent_8)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.summaryOrderType;
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.showAsap;
    ck(v,6,0,currVal_1);
    const currVal_2:any = co.summaryTime;
    ck(v,9,0,currVal_2);
    const currVal_3:any = co.summaryTable;
    ck(v,12,0,currVal_3);
    const currVal_4:any = co.primaryStore;
    ck(v,15,0,currVal_4);
    const currVal_5:any = co.primaryAddress;
    ck(v,18,0,currVal_5);
  },(null as any));
}
function View_OrderingContextPanelComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'ordering-context-body-summary-query'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform(co.query));
    ck(v,1,0,currVal_0);
  });
}
function View_OrderingContextPanelComponent_11(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'ordering-context-body-summary-secondary-store'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.secondaryStore;
    ck(v,1,0,currVal_0);
  });
}
function View_OrderingContextPanelComponent_12(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-link',[[
        'class',
        'ordering-context-body-summary-secondary-link'
      ]
      ],(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.orderingContextModel.viewCurrentStore()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import4.View_LinkComponent_0,import4.RenderType_LinkComponent)),
      import0.ɵdid(49152,(null as any),0,import5.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.storeDetailsLink;
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_OrderingContextPanelComponent_13(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'ordering-context-body-summary-secondary-address'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.secondaryAddress;
    ck(v,1,0,currVal_0);
  });
}
function View_OrderingContextPanelComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'ordering-context-body-summary-secondary'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextPanelComponent_11)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextPanelComponent_12)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextPanelComponent_13)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.secondaryStore;
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.storeDetailsLink;
    ck(v,6,0,currVal_1);
    const currVal_2:any = co.secondaryAddress;
    ck(v,9,0,currVal_2);
  },(null as any));
}
function View_OrderingContextPanelComponent_14(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-button',[[
        'class',
        'ordering-context-body-action'
      ]
    ],[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.orderingContextModel.changeOrderingContext(co.timeOnly)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import6.View_ButtonComponent_0,import6.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import7.ButtonComponent,[
      import0.ElementRef,
      import8.SessionModel,
      import0.ChangeDetectorRef,
      import9.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      tier: [
        1,
        'tier'
      ]
      ,
      prominence: [
        2,
        'prominence'
      ]

    }
    ,(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = co.actionLabel;
    const currVal_28:any = co.ButtonTier.SECOND;
    const currVal_29:any = co.ButtonProminence.HIGH;
    ck(v,1,0,currVal_27,currVal_28,currVal_29);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_OrderingContextPanelComponent_16(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-link',([] as any[]),(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.orderingContextModel.changeExpectedCompletion()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import4.View_LinkComponent_0,import4.RenderType_LinkComponent)),
      import0.ɵdid(49152,[[
        1,
        4
      ]
      ],0,import5.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    const currVal_0:any = 'woa.button.ordering-context.selectOrderTime';
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_OrderingContextPanelComponent_15(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'woa-content-message',([] as any[]),[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import10.View_ContentMessageComponent_0,import10.RenderType_ContentMessageComponent)),
    import0.ɵdid(5488640,(null as any),1,import11.ContentMessageComponent,[
      import0.ElementRef,
      import12.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      text: [
        1,
        'text'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,1,{links: 1}),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),1,1,(null as any),View_OrderingContextPanelComponent_16)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.ERROR;
    const currVal_9:any = co.orderModel.cannotAllocateOrderTimeMessage;
    ck(v,1,0,currVal_8,currVal_9);
    const currVal_10:any = co.showSelectTimeLink;
    ck(v,5,0,currVal_10);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
export function View_OrderingContextPanelComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import13.HtmlPipe,[import14.DomSanitizer]),
      (l()(),import0.ɵeld(0,(null as any),(null as any),19,'div',[[
        'class',
        'ordering-context-body'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'ordering-context-body-summary'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'ordering-context-body-summary'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextPanelComponent_1)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextPanelComponent_9)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextPanelComponent_10)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderingContextPanelComponent_14)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_OrderingContextPanelComponent_15)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import3.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import15.OrderingContextPanelComponent = v.component;
    const currVal_0:any = (((((co.summaryOrderType || co.showAsap) || co.summaryTime) || co.summaryTable) || co.primaryStore) || co.primaryAddress);
    ck(v,8,0,currVal_0);
    const currVal_1:any = co.query;
    ck(v,11,0,currVal_1);
    const currVal_2:any = ((co.secondaryStore || co.storeDetailsLink) || co.secondaryAddress);
    ck(v,14,0,currVal_2);
    const currVal_3:any = co.showContextAction;
    ck(v,19,0,currVal_3);
    const currVal_4:any = (co.orderModel.cannotAllocateTime && !import0.ɵunv(v,23,0,import0.ɵnov(v,24).transform(co.OrderingContextEvents.evaluatingExpectedCompletionChange$)));
    ck(v,23,0,currVal_4);
  },(null as any));
}
function View_OrderingContextPanelComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-ordering-context-panel',([] as any[]),(null as any),(null as any),(null as any),View_OrderingContextPanelComponent_0,RenderType_OrderingContextPanelComponent)),
    import0.ɵdid(245760,(null as any),0,import15.OrderingContextPanelComponent,[
      import16.OrderingContextModel,
      import17.OrderModel,
      import9.ResponsiveService,
      import18.NavigationService,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const OrderingContextPanelComponentNgFactory:import0.ComponentFactory<import15.OrderingContextPanelComponent> = import0.ɵccf('woa-ordering-context-panel',import15.OrderingContextPanelComponent,View_OrderingContextPanelComponent_Host_0,{timeOnly: 'timeOnly'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/ordering-context/ordering-context-panel/ordering-context-panel.component.ngfactory.ts